import React, {Fragment, FunctionComponent, useCallback, useEffect, useState} from "react";
import {Garage, PartnerConfig, Place} from "@App/types";
import {GarageListMapMarker} from "./GarageListMapMarker";
import {MapContainer, TileLayer, Marker, Popup} from "react-leaflet";
import L, {Map as LeafletMap} from "leaflet";
import {renderToStaticMarkup} from "react-dom/server";
import "leaflet/dist/leaflet.css"
import GarageListPopup from "@App/components/GarageList/Map/GarageListPopup";
import google from "@App/public/assets/images/google.png";



export type GarageListMapProps = {
    garages: Garage[]
    center: Place
    onClose?: () => void,
    partner: PartnerConfig,
    onSelectGarage: (garage: Garage) => void
};


const GarageListMap: FunctionComponent<GarageListMapProps> = ((props: GarageListMapProps) => {

    const [map, setMap] = useState<LeafletMap|null>(null)

    const [selectedGarage, setSelectedGarage] = useState<Garage|null>(null)

    const selectMarker = useCallback((garage: Garage, open: boolean) => {
        if (open) {
            setSelectedGarage(garage)
            return
        }
        setSelectedGarage(null)
    }, [])

    useEffect(() => {
        if(props.center.lat !== 0 && props.center.lon !== 0){
            map?.setView([props.center.lat, props.center.lon],props.center.name === 'Deutschland' ? 6 : 11, {animate: true});
        }
    }, [props.garages, props.center])

    return (
        <div className={'w-full h-full'}>
            <MapContainer center={[props.center.lat, props.center.lon]} zoom={props.center.name === 'Deutschland' ? 6 : 11} scrollWheelZoom={false} ref={(map) => setMap(map)} style={{'width':'100%', 'height': '100%'}}>
                <TileLayer
                    subdomains={['mt0','mt1','mt2','mt3']}
                    maxZoom={20}
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                    url="http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&hl=de"
                />
                {props.center.name !== 'Deutschland' && (
                    <Marker position={[props.center.lat, props.center.lon]} icon={L.divIcon({
                        html: renderToStaticMarkup(<MapLocationIcon/>)
                    })} />
                )}
                {props.garages.map((garage, iterator) => (
                    <Fragment key={iterator}>
                    {(garage.lat && garage.lon && garage.baseCity) && (
                            <Marker key={garage.id} position={[garage.lat, garage.lon]} riseOnHover={true} icon={L.divIcon({

                        html: renderToStaticMarkup(<GarageListMapMarker garage={garage}
                                                                        open={selectedGarage ? selectedGarage.id === garage.id : false}
                                                                        onToggle={selectMarker}
                                                                        lat={garage.lat}
                                                                        lng={garage.lon}
                                                                        onClick={props.onSelectGarage}
                                                                        partner={props.partner}
                        />)
                    })}>
                        <Popup className={`garageListMapMarker__overlay`}>
                           <GarageListPopup garage={garage} partner={props.partner}/>
                        </Popup>
                    </Marker>
                    )}
                    </Fragment>
                ))}
                <div className={'copyright absolute bottom-2 left-2 z-[9999]'}>
                    <img src={google.src} alt={'Google'}/>
                </div>
            </MapContainer>
        </div>
    );
})


export const MapLocationIcon = (props: any) => <svg xmlns="http://www.w3.org/2000/svg" width="44.713" height="53.615"
                                               viewBox="0 0 44.713 53.615">
    <defs>
        <filter x="0" y="0" width="44.713" height="53.615" filterUnits="userSpaceOnUse">
            <feGaussianBlur stdDeviation="3" result="blur"></feGaussianBlur>
            <feFlood floodOpacity="0.161"></feFlood>
            <feComposite operator="in" in2="blur"></feComposite>
            <feComposite in2="SourceGraphic"></feComposite>
        </filter>
    </defs>
    <g transform="translate(-14.776 -135.686)">
        <g transform="matrix(1, 0, 0, 1, 14.78, 135.69)" >
            <path data-name="Pfad 167"
                  d="M37.131,141.686a13.355,13.355,0,0,0-13.355,13.355c0,5.386,1.877,6.887,11.984,21.538a1.667,1.667,0,0,0,2.318.428,1.648,1.648,0,0,0,.428-.428c10.108-14.65,11.984-16.159,11.984-21.538a13.354,13.354,0,0,0-13.355-13.355h0m0,18.482a5.127,5.127,0,1,1,5.127-5.127,5.127,5.127,0,0,1-5.127,5.127"
                  transform="translate(-14.78 -135.69)" fill="var(--color-primary)"/>
        </g>
    </g>
</svg>

export default GarageListMap